/* tslint:disable */
/* eslint-disable */
/**
 * Joule Conductor Cloud
 * This specification document describes the Joule Technologies Application Programming Interface  (API). The endpoints, message formats and status codes are explained in this document. ## Communication  ### Base URI  The base Uniform Resource Identifier (URI) is: https://user-api.joule-cloud.com/v2 This URI is the prefix for all endpoints described in this document. ### Body format  The endpoints of the API expecting a body must be in JavaScript Object Notation (JSON) format.  Response bodies from the endpoints also adhere to this standard, unless otherwise stated.  Responses will include a Content-Type header indicating the ‘application/json’ type. An invalid  or missing body will result in a 400-status code accompanied by an error code to specify the  nature of the error. ### Security The API uses HTTPS as the underlying protocol to transfer data. The server hosts a certificate  to set up a secure connection using Transport Layer Security (TLS) version 1.2. The authenticity  of the server certificate is verifiable by the client using publicly available sources.  #### Authentication and authorization  The API should only be called by legitimate users with the correct access rights. The API uses  the Open Authorization 2.0 (OAuth) standard to achieve this. Every request to the API should  include a bearer access token in the JSON Web Token (JWT) format in the Authorization header.  The header should be formatted such as in the example below.  ```   {“Authorization”: “Bearer <JWT>”}  ``` The JWT must be acquired from one of the following identity providers:   * joule-technologies.eu.auth0.com    * inventum-app.eu.auth0.com    * joule-app.eu.auth0.com   For help regarding gaining an access token you can find the docs for Auth0  [here](https://auth0.com/docs/secure/tokens/access-tokens/get-access-tokens). The JWT must be intended for one of the following audiences:    * https://user-api.joule-cloud.com   If the authorization header does not match the requirements stated above the API will respond  with a 401-status code accompanied by an error code to specify the nature of the error.  ### Timeout The API specifies a maximum amount of time between a request and the response to avoid blocking  either side. The general timeout that has been set for each endpoint is 3000 milliseconds.  This timeout is used unless otherwise stated in the respective endpoint documentation.  If the server is unable to respond within this maximum time, the response contains a 504-status  code. The client may retry the request. The time out for a stream to be open is 1800 seconds.  If the stream is still open passed the experitation the server will close the stream. ### Rate limits  No rate limit is currently imposed. ### Diagnostics response  The diagnostics response provides the caller of the API with more information in case of a  failed request. This information can be used for debugging and recovery/retrying purposes.  The diagnostics response is always included under the “diagnostics” key if the response  has a body. 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Account,
  ChangePasswordRequest,
  Config,
  ConfigResponse,
  DeviceListResponse,
  Diagnostics,
  DynamicContent,
  ForYouPost,
  GetConsent200Response,
  GetCurrentUser200Response,
  GetHistoryRangeSystem200ResponseInner,
  GetStream200Response,
  GetSupportedSensors200Response,
  GetSystem200Response,
  GetSystemStream200Response,
  GetUsers200Response,
  HistoricalErrorsResponse,
  HistoryDataPoints,
  LinkDevice200Response,
  LinkDeviceRequest,
  Systems,
  TranslationFiles,
  UpdateAccountRequest,
  UpdateUserRequest,
  UpdateUserRoleByEmailRequest,
  User,
} from '../models/index';
import {
    AccountFromJSON,
    AccountToJSON,
    ChangePasswordRequestFromJSON,
    ChangePasswordRequestToJSON,
    ConfigFromJSON,
    ConfigToJSON,
    ConfigResponseFromJSON,
    ConfigResponseToJSON,
    DeviceListResponseFromJSON,
    DeviceListResponseToJSON,
    DiagnosticsFromJSON,
    DiagnosticsToJSON,
    DynamicContentFromJSON,
    DynamicContentToJSON,
    ForYouPostFromJSON,
    ForYouPostToJSON,
    GetConsent200ResponseFromJSON,
    GetConsent200ResponseToJSON,
    GetCurrentUser200ResponseFromJSON,
    GetCurrentUser200ResponseToJSON,
    GetHistoryRangeSystem200ResponseInnerFromJSON,
    GetHistoryRangeSystem200ResponseInnerToJSON,
    GetStream200ResponseFromJSON,
    GetStream200ResponseToJSON,
    GetSupportedSensors200ResponseFromJSON,
    GetSupportedSensors200ResponseToJSON,
    GetSystem200ResponseFromJSON,
    GetSystem200ResponseToJSON,
    GetSystemStream200ResponseFromJSON,
    GetSystemStream200ResponseToJSON,
    GetUsers200ResponseFromJSON,
    GetUsers200ResponseToJSON,
    HistoricalErrorsResponseFromJSON,
    HistoricalErrorsResponseToJSON,
    HistoryDataPointsFromJSON,
    HistoryDataPointsToJSON,
    LinkDevice200ResponseFromJSON,
    LinkDevice200ResponseToJSON,
    LinkDeviceRequestFromJSON,
    LinkDeviceRequestToJSON,
    SystemsFromJSON,
    SystemsToJSON,
    TranslationFilesFromJSON,
    TranslationFilesToJSON,
    UpdateAccountRequestFromJSON,
    UpdateAccountRequestToJSON,
    UpdateUserRequestFromJSON,
    UpdateUserRequestToJSON,
    UpdateUserRoleByEmailRequestFromJSON,
    UpdateUserRoleByEmailRequestToJSON,
    UserFromJSON,
    UserToJSON,
} from '../models/index';

export interface ChangePasswordOperationRequest {
    updateData: ChangePasswordRequest;
}

export interface GetAccountRequest {
    accountId: string;
}

export interface GetConfigRequest {
    deviceId: string;
    filter: Set<string>;
}

export interface GetConsentRequest {
    consentType: GetConsentConsentTypeEnum;
}

export interface GetDynamicContentRequest {
    contentType: string;
    language: string;
}

export interface GetErrorsRequest {
    systemId: string;
    size?: number;
    page?: number;
}

export interface GetForYouPostByIdRequest {
    id: string;
}

export interface GetForYouPostsRequest {
    tags?: Array<string>;
}

export interface GetHistoryLatestRequest {
    deviceId: string;
    filter: Set<string>;
}

export interface GetHistoryRangeRequest {
    deviceId: string;
    resolution: GetHistoryRangeResolutionEnum;
    startTime: Date;
    endTime: Date;
    filter: Set<string>;
}

export interface GetHistoryRangeSystemRequest {
    systemId: string;
    resolution: GetHistoryRangeSystemResolutionEnum;
    startTime: Date;
    endTime: Date;
    filter: Set<string>;
}

export interface GetStreamRequest {
    deviceId: string;
    filter: Set<string>;
}

export interface GetSupportedSensorsRequest {
    deviceId: string;
}

export interface GetSystemRequest {
    systemId: string;
}

export interface GetSystemStreamRequest {
    systemId: string;
}

export interface GetSystemsRequest {
    size?: number;
    page?: number;
    search?: string;
    deviceNames?: Set<string>;
}

export interface GetUserRequest {
    userId: string;
}

export interface GetUsersRequest {
    size?: number;
    page?: number;
    filter?: string;
    sort?: string;
}

export interface GrantConsentRequest {
    consentType: GrantConsentConsentTypeEnum;
}

export interface LinkDeviceOperationRequest {
    device: LinkDeviceRequest;
}

export interface RevokeConsentRequest {
    consentType: RevokeConsentConsentTypeEnum;
}

export interface SetConfigRequest {
    deviceId: string;
    config: Config;
}

export interface UnlinkDeviceRequest {
    deviceId: string;
}

export interface UpdateAccountOperationRequest {
    accountId: string;
    updateData: UpdateAccountRequest;
}

export interface UpdateUserOperationRequest {
    userId: string;
    updateData: UpdateUserRequest;
}

export interface UpdateUserRoleByEmailOperationRequest {
    updateData: UpdateUserRoleByEmailRequest;
}

/**
 * 
 */
export class ConsumerApi extends runtime.BaseAPI {

    /**
     * Creates request options for changePassword without sending the request
     */
    async changePasswordRequestOpts(requestParameters: ChangePasswordOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['updateData'] == null) {
            throw new runtime.RequiredError(
                'updateData',
                'Required parameter "updateData" was null or undefined when calling changePassword().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/consumer/users/self/change-password`;

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ChangePasswordRequestToJSON(requestParameters['updateData']),
        };
    }

    /**
     * Changes the password of the current user
     */
    async changePasswordRaw(requestParameters: ChangePasswordOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Diagnostics>> {
        const requestOptions = await this.changePasswordRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DiagnosticsFromJSON(jsonValue));
    }

    /**
     * Changes the password of the current user
     */
    async changePassword(requestParameters: ChangePasswordOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Diagnostics> {
        const response = await this.changePasswordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteCurrentUser without sending the request
     */
    async deleteCurrentUserRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/consumer/users/self`;

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Deletes the current user. The user can no longer make requests when this request is successful.
     */
    async deleteCurrentUserRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Diagnostics>> {
        const requestOptions = await this.deleteCurrentUserRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DiagnosticsFromJSON(jsonValue));
    }

    /**
     * Deletes the current user. The user can no longer make requests when this request is successful.
     */
    async deleteCurrentUser(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Diagnostics> {
        const response = await this.deleteCurrentUserRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getAccount without sending the request
     */
    async getAccountRequestOpts(requestParameters: GetAccountRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling getAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/consumer/account/{accountId}`;
        urlPath = urlPath.replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters['accountId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get info about a specific account.
     */
    async getAccountRaw(requestParameters: GetAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Account>> {
        const requestOptions = await this.getAccountRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccountFromJSON(jsonValue));
    }

    /**
     * Get info about a specific account.
     */
    async getAccount(requestParameters: GetAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Account> {
        const response = await this.getAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getConfig without sending the request
     */
    async getConfigRequestOpts(requestParameters: GetConfigRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deviceId'] == null) {
            throw new runtime.RequiredError(
                'deviceId',
                'Required parameter "deviceId" was null or undefined when calling getConfig().'
            );
        }

        if (requestParameters['filter'] == null) {
            throw new runtime.RequiredError(
                'filter',
                'Required parameter "filter" was null or undefined when calling getConfig().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = Array.from(requestParameters['filter'])!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/consumer/devices/{deviceId}/config`;
        urlPath = urlPath.replace(`{${"deviceId"}}`, encodeURIComponent(String(requestParameters['deviceId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get specified fields of a device\'s configuration
     */
    async getConfigRaw(requestParameters: GetConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConfigResponse>> {
        const requestOptions = await this.getConfigRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConfigResponseFromJSON(jsonValue));
    }

    /**
     * Get specified fields of a device\'s configuration
     */
    async getConfig(requestParameters: GetConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConfigResponse> {
        const response = await this.getConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getConsent without sending the request
     */
    async getConsentRequestOpts(requestParameters: GetConsentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['consentType'] == null) {
            throw new runtime.RequiredError(
                'consentType',
                'Required parameter "consentType" was null or undefined when calling getConsent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/consumer/consents/{consentType}`;
        urlPath = urlPath.replace(`{${"consentType"}}`, encodeURIComponent(String(requestParameters['consentType'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * The details include the accepted status
     * Retrieve the details of the specified consent type
     */
    async getConsentRaw(requestParameters: GetConsentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetConsent200Response>> {
        const requestOptions = await this.getConsentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetConsent200ResponseFromJSON(jsonValue));
    }

    /**
     * The details include the accepted status
     * Retrieve the details of the specified consent type
     */
    async getConsent(requestParameters: GetConsentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetConsent200Response> {
        const response = await this.getConsentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getCurrentUser without sending the request
     */
    async getCurrentUserRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/consumer/users/self`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get info about the current user.
     */
    async getCurrentUserRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCurrentUser200Response>> {
        const requestOptions = await this.getCurrentUserRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCurrentUser200ResponseFromJSON(jsonValue));
    }

    /**
     * Get info about the current user.
     */
    async getCurrentUser(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCurrentUser200Response> {
        const response = await this.getCurrentUserRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getDevices without sending the request
     */
    async getDevicesRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/consumer/devices`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Acquire a list of devices belonging to this account
     */
    async getDevicesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeviceListResponse>> {
        const requestOptions = await this.getDevicesRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeviceListResponseFromJSON(jsonValue));
    }

    /**
     * Acquire a list of devices belonging to this account
     */
    async getDevices(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeviceListResponse> {
        const response = await this.getDevicesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getDynamicContent without sending the request
     */
    async getDynamicContentRequestOpts(requestParameters: GetDynamicContentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling getDynamicContent().'
            );
        }

        if (requestParameters['language'] == null) {
            throw new runtime.RequiredError(
                'language',
                'Required parameter "language" was null or undefined when calling getDynamicContent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/consumer/dynamic-content/{contentType}/{language}`;
        urlPath = urlPath.replace(`{${"contentType"}}`, encodeURIComponent(String(requestParameters['contentType'])));
        urlPath = urlPath.replace(`{${"language"}}`, encodeURIComponent(String(requestParameters['language'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get dynamic content by name.
     */
    async getDynamicContentRaw(requestParameters: GetDynamicContentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DynamicContent>> {
        const requestOptions = await this.getDynamicContentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DynamicContentFromJSON(jsonValue));
    }

    /**
     * Get dynamic content by name.
     */
    async getDynamicContent(requestParameters: GetDynamicContentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DynamicContent> {
        const response = await this.getDynamicContentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getErrors without sending the request
     */
    async getErrorsRequestOpts(requestParameters: GetErrorsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['systemId'] == null) {
            throw new runtime.RequiredError(
                'systemId',
                'Required parameter "systemId" was null or undefined when calling getErrors().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/consumer/systems/{systemId}/errors`;
        urlPath = urlPath.replace(`{${"systemId"}}`, encodeURIComponent(String(requestParameters['systemId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get a paginated list of errors
     */
    async getErrorsRaw(requestParameters: GetErrorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HistoricalErrorsResponse>> {
        const requestOptions = await this.getErrorsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HistoricalErrorsResponseFromJSON(jsonValue));
    }

    /**
     * Get a paginated list of errors
     */
    async getErrors(requestParameters: GetErrorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HistoricalErrorsResponse> {
        const response = await this.getErrorsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getForYouPostById without sending the request
     */
    async getForYouPostByIdRequestOpts(requestParameters: GetForYouPostByIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getForYouPostById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/consumer/for-you/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get \"For you\" post by id
     */
    async getForYouPostByIdRaw(requestParameters: GetForYouPostByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ForYouPost>> {
        const requestOptions = await this.getForYouPostByIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ForYouPostFromJSON(jsonValue));
    }

    /**
     * Get \"For you\" post by id
     */
    async getForYouPostById(requestParameters: GetForYouPostByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ForYouPost> {
        const response = await this.getForYouPostByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getForYouPosts without sending the request
     */
    async getForYouPostsRequestOpts(requestParameters: GetForYouPostsRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['tags'] != null) {
            queryParameters['tags'] = requestParameters['tags']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/consumer/for-you`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get \"For you\" posts for the user app
     */
    async getForYouPostsRaw(requestParameters: GetForYouPostsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ForYouPost>>> {
        const requestOptions = await this.getForYouPostsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ForYouPostFromJSON));
    }

    /**
     * Get \"For you\" posts for the user app
     */
    async getForYouPosts(requestParameters: GetForYouPostsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ForYouPost>> {
        const response = await this.getForYouPostsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getHistoryLatest without sending the request
     */
    async getHistoryLatestRequestOpts(requestParameters: GetHistoryLatestRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deviceId'] == null) {
            throw new runtime.RequiredError(
                'deviceId',
                'Required parameter "deviceId" was null or undefined when calling getHistoryLatest().'
            );
        }

        if (requestParameters['filter'] == null) {
            throw new runtime.RequiredError(
                'filter',
                'Required parameter "filter" was null or undefined when calling getHistoryLatest().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = Array.from(requestParameters['filter'])!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/consumer/history/{deviceId}/latest`;
        urlPath = urlPath.replace(`{${"deviceId"}}`, encodeURIComponent(String(requestParameters['deviceId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get the latest historical data
     */
    async getHistoryLatestRaw(requestParameters: GetHistoryLatestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HistoryDataPoints>> {
        const requestOptions = await this.getHistoryLatestRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HistoryDataPointsFromJSON(jsonValue));
    }

    /**
     * Get the latest historical data
     */
    async getHistoryLatest(requestParameters: GetHistoryLatestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HistoryDataPoints> {
        const response = await this.getHistoryLatestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getHistoryRange without sending the request
     */
    async getHistoryRangeRequestOpts(requestParameters: GetHistoryRangeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deviceId'] == null) {
            throw new runtime.RequiredError(
                'deviceId',
                'Required parameter "deviceId" was null or undefined when calling getHistoryRange().'
            );
        }

        if (requestParameters['resolution'] == null) {
            throw new runtime.RequiredError(
                'resolution',
                'Required parameter "resolution" was null or undefined when calling getHistoryRange().'
            );
        }

        if (requestParameters['startTime'] == null) {
            throw new runtime.RequiredError(
                'startTime',
                'Required parameter "startTime" was null or undefined when calling getHistoryRange().'
            );
        }

        if (requestParameters['endTime'] == null) {
            throw new runtime.RequiredError(
                'endTime',
                'Required parameter "endTime" was null or undefined when calling getHistoryRange().'
            );
        }

        if (requestParameters['filter'] == null) {
            throw new runtime.RequiredError(
                'filter',
                'Required parameter "filter" was null or undefined when calling getHistoryRange().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = Array.from(requestParameters['filter'])!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/consumer/history/{deviceId}/{startTime}/{endTime}/{resolution}`;
        urlPath = urlPath.replace(`{${"deviceId"}}`, encodeURIComponent(String(requestParameters['deviceId'])));
        urlPath = urlPath.replace(`{${"resolution"}}`, encodeURIComponent(String(requestParameters['resolution'])));
        if (requestParameters['startTime'] instanceof Date) {
            urlPath = urlPath.replace(`{${"startTime"}}`, encodeURIComponent(requestParameters['startTime'].toISOString()));
        } else {
            urlPath = urlPath.replace(`{${"startTime"}}`, encodeURIComponent(String(requestParameters['startTime'])));
        }
        if (requestParameters['endTime'] instanceof Date) {
            urlPath = urlPath.replace(`{${"endTime"}}`, encodeURIComponent(requestParameters['endTime'].toISOString()));
        } else {
            urlPath = urlPath.replace(`{${"endTime"}}`, encodeURIComponent(String(requestParameters['endTime'])));
        }

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get historical data in the specified range
     */
    async getHistoryRangeRaw(requestParameters: GetHistoryRangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HistoryDataPoints>> {
        const requestOptions = await this.getHistoryRangeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HistoryDataPointsFromJSON(jsonValue));
    }

    /**
     * Get historical data in the specified range
     */
    async getHistoryRange(requestParameters: GetHistoryRangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HistoryDataPoints> {
        const response = await this.getHistoryRangeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getHistoryRangeSystem without sending the request
     */
    async getHistoryRangeSystemRequestOpts(requestParameters: GetHistoryRangeSystemRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['systemId'] == null) {
            throw new runtime.RequiredError(
                'systemId',
                'Required parameter "systemId" was null or undefined when calling getHistoryRangeSystem().'
            );
        }

        if (requestParameters['resolution'] == null) {
            throw new runtime.RequiredError(
                'resolution',
                'Required parameter "resolution" was null or undefined when calling getHistoryRangeSystem().'
            );
        }

        if (requestParameters['startTime'] == null) {
            throw new runtime.RequiredError(
                'startTime',
                'Required parameter "startTime" was null or undefined when calling getHistoryRangeSystem().'
            );
        }

        if (requestParameters['endTime'] == null) {
            throw new runtime.RequiredError(
                'endTime',
                'Required parameter "endTime" was null or undefined when calling getHistoryRangeSystem().'
            );
        }

        if (requestParameters['filter'] == null) {
            throw new runtime.RequiredError(
                'filter',
                'Required parameter "filter" was null or undefined when calling getHistoryRangeSystem().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = Array.from(requestParameters['filter'])!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/consumer/history/system/{systemId}/{startTime}/{endTime}/{resolution}`;
        urlPath = urlPath.replace(`{${"systemId"}}`, encodeURIComponent(String(requestParameters['systemId'])));
        urlPath = urlPath.replace(`{${"resolution"}}`, encodeURIComponent(String(requestParameters['resolution'])));
        if (requestParameters['startTime'] instanceof Date) {
            urlPath = urlPath.replace(`{${"startTime"}}`, encodeURIComponent(requestParameters['startTime'].toISOString()));
        } else {
            urlPath = urlPath.replace(`{${"startTime"}}`, encodeURIComponent(String(requestParameters['startTime'])));
        }
        if (requestParameters['endTime'] instanceof Date) {
            urlPath = urlPath.replace(`{${"endTime"}}`, encodeURIComponent(requestParameters['endTime'].toISOString()));
        } else {
            urlPath = urlPath.replace(`{${"endTime"}}`, encodeURIComponent(String(requestParameters['endTime'])));
        }

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get historical data in the specified range for a whole system
     */
    async getHistoryRangeSystemRaw(requestParameters: GetHistoryRangeSystemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetHistoryRangeSystem200ResponseInner>>> {
        const requestOptions = await this.getHistoryRangeSystemRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetHistoryRangeSystem200ResponseInnerFromJSON));
    }

    /**
     * Get historical data in the specified range for a whole system
     */
    async getHistoryRangeSystem(requestParameters: GetHistoryRangeSystemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetHistoryRangeSystem200ResponseInner>> {
        const response = await this.getHistoryRangeSystemRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getStream without sending the request
     */
    async getStreamRequestOpts(requestParameters: GetStreamRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deviceId'] == null) {
            throw new runtime.RequiredError(
                'deviceId',
                'Required parameter "deviceId" was null or undefined when calling getStream().'
            );
        }

        if (requestParameters['filter'] == null) {
            throw new runtime.RequiredError(
                'filter',
                'Required parameter "filter" was null or undefined when calling getStream().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = Array.from(requestParameters['filter'])!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/consumer/devices/{deviceId}/stream`;
        urlPath = urlPath.replace(`{${"deviceId"}}`, encodeURIComponent(String(requestParameters['deviceId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Opens a stream to receive updates from the device. These updates can include sensor readings, statuses, and configurations changed on the device’s HMI. The request body specifies what updates should be sent. The first response contains the latest known values of all streamable data, if no values are known the first response will contain keys with `null` values . Consecutive responses will likely not include values for all the requested updates, as these updates are sent by the device at different intervals.  ## Data stream Devices connected to the server are autonomous. These devices gather sensor data, and some allow settings to be changed via a Human Machine Interface (HMI). This data is provided to the client using [Server-Sent Event (SSE)](https://html.spec.whatwg.org/multipage/server-sent-events.html). This method eliminates the need for (long-)polling by the client, this results in a reduction in traffic, server load and complexity. ### Response To stop receiving events from the server, the client may simply close the connection. The data in the SSE response body is formatted as follows, this is according to the SSE specification. The data byte string can be interpreted by a JSON parser. `data: <data byte   string>\\n\\n`  ### Timeout The maximum amount of time a stream is allowed to be open is 1800 seconds. The stream is closed by the server if this maximum duration is reached. 
     * Opens a stream to receive updates from the device
     */
    async getStreamRaw(requestParameters: GetStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetStream200Response>> {
        const requestOptions = await this.getStreamRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetStream200ResponseFromJSON(jsonValue));
    }

    /**
     * Opens a stream to receive updates from the device. These updates can include sensor readings, statuses, and configurations changed on the device’s HMI. The request body specifies what updates should be sent. The first response contains the latest known values of all streamable data, if no values are known the first response will contain keys with `null` values . Consecutive responses will likely not include values for all the requested updates, as these updates are sent by the device at different intervals.  ## Data stream Devices connected to the server are autonomous. These devices gather sensor data, and some allow settings to be changed via a Human Machine Interface (HMI). This data is provided to the client using [Server-Sent Event (SSE)](https://html.spec.whatwg.org/multipage/server-sent-events.html). This method eliminates the need for (long-)polling by the client, this results in a reduction in traffic, server load and complexity. ### Response To stop receiving events from the server, the client may simply close the connection. The data in the SSE response body is formatted as follows, this is according to the SSE specification. The data byte string can be interpreted by a JSON parser. `data: <data byte   string>\\n\\n`  ### Timeout The maximum amount of time a stream is allowed to be open is 1800 seconds. The stream is closed by the server if this maximum duration is reached. 
     * Opens a stream to receive updates from the device
     */
    async getStream(requestParameters: GetStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetStream200Response> {
        const response = await this.getStreamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getSupportedSensors without sending the request
     */
    async getSupportedSensorsRequestOpts(requestParameters: GetSupportedSensorsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deviceId'] == null) {
            throw new runtime.RequiredError(
                'deviceId',
                'Required parameter "deviceId" was null or undefined when calling getSupportedSensors().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/consumer/devices/{deviceId}/sensors/supported`;
        urlPath = urlPath.replace(`{${"deviceId"}}`, encodeURIComponent(String(requestParameters['deviceId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get a list of supported sensors for the specified device
     */
    async getSupportedSensorsRaw(requestParameters: GetSupportedSensorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSupportedSensors200Response>> {
        const requestOptions = await this.getSupportedSensorsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSupportedSensors200ResponseFromJSON(jsonValue));
    }

    /**
     * Get a list of supported sensors for the specified device
     */
    async getSupportedSensors(requestParameters: GetSupportedSensorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSupportedSensors200Response> {
        const response = await this.getSupportedSensorsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getSystem without sending the request
     */
    async getSystemRequestOpts(requestParameters: GetSystemRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['systemId'] == null) {
            throw new runtime.RequiredError(
                'systemId',
                'Required parameter "systemId" was null or undefined when calling getSystem().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/consumer/systems/{systemId}`;
        urlPath = urlPath.replace(`{${"systemId"}}`, encodeURIComponent(String(requestParameters['systemId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get one specific system
     */
    async getSystemRaw(requestParameters: GetSystemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSystem200Response>> {
        const requestOptions = await this.getSystemRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSystem200ResponseFromJSON(jsonValue));
    }

    /**
     * Get one specific system
     */
    async getSystem(requestParameters: GetSystemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSystem200Response> {
        const response = await this.getSystemRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getSystemStream without sending the request
     */
    async getSystemStreamRequestOpts(requestParameters: GetSystemStreamRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['systemId'] == null) {
            throw new runtime.RequiredError(
                'systemId',
                'Required parameter "systemId" was null or undefined when calling getSystemStream().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/consumer/systems/{systemId}/stream`;
        urlPath = urlPath.replace(`{${"systemId"}}`, encodeURIComponent(String(requestParameters['systemId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Opens a stream to receive updates from the devices in a system. These updates can include sensor readings, statuses, and configurations changed on the devices. The first response contains the latest known values of all streamable data, if no values are known the first response will contain keys with `null` values . When a devices changed event is received, the client must re-open the stream to get the values of the newly linked device.  Devices changed is not streamed in the initial response. ### Response To stop receiving events from the server, the client may simply close the connection. The data in the SSE response body is formatted as follows, this is according to the SSE specification. The data byte string can be interpreted by a JSON parser. `data: <data byte   string>\\n\\n` 
     * Opens a stream to receive updates from every device in a system
     */
    async getSystemStreamRaw(requestParameters: GetSystemStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSystemStream200Response>> {
        const requestOptions = await this.getSystemStreamRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSystemStream200ResponseFromJSON(jsonValue));
    }

    /**
     * Opens a stream to receive updates from the devices in a system. These updates can include sensor readings, statuses, and configurations changed on the devices. The first response contains the latest known values of all streamable data, if no values are known the first response will contain keys with `null` values . When a devices changed event is received, the client must re-open the stream to get the values of the newly linked device.  Devices changed is not streamed in the initial response. ### Response To stop receiving events from the server, the client may simply close the connection. The data in the SSE response body is formatted as follows, this is according to the SSE specification. The data byte string can be interpreted by a JSON parser. `data: <data byte   string>\\n\\n` 
     * Opens a stream to receive updates from every device in a system
     */
    async getSystemStream(requestParameters: GetSystemStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSystemStream200Response> {
        const response = await this.getSystemStreamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getSystems without sending the request
     */
    async getSystemsRequestOpts(requestParameters: GetSystemsRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['deviceNames'] != null) {
            queryParameters['deviceNames'] = Array.from(requestParameters['deviceNames'])!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/consumer/systems`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get a paginated list of systems
     */
    async getSystemsRaw(requestParameters: GetSystemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Systems>> {
        const requestOptions = await this.getSystemsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SystemsFromJSON(jsonValue));
    }

    /**
     * Get a paginated list of systems
     */
    async getSystems(requestParameters: GetSystemsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Systems> {
        const response = await this.getSystemsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getTranslations without sending the request
     */
    async getTranslationsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/consumer/translations`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get translations for the user app
     */
    async getTranslationsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TranslationFiles>> {
        const requestOptions = await this.getTranslationsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TranslationFilesFromJSON(jsonValue));
    }

    /**
     * Get translations for the user app
     */
    async getTranslations(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TranslationFiles> {
        const response = await this.getTranslationsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getUser without sending the request
     */
    async getUserRequestOpts(requestParameters: GetUserRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling getUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/consumer/users/{userId}`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get info about a specific user.
     */
    async getUserRaw(requestParameters: GetUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<User>> {
        const requestOptions = await this.getUserRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserFromJSON(jsonValue));
    }

    /**
     * Get info about a specific user.
     */
    async getUser(requestParameters: GetUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<User> {
        const response = await this.getUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getUsers without sending the request
     */
    async getUsersRequestOpts(requestParameters: GetUsersRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/consumer/users`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get all managed users of which the email address is known.
     */
    async getUsersRaw(requestParameters: GetUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUsers200Response>> {
        const requestOptions = await this.getUsersRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUsers200ResponseFromJSON(jsonValue));
    }

    /**
     * Get all managed users of which the email address is known.
     */
    async getUsers(requestParameters: GetUsersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUsers200Response> {
        const response = await this.getUsersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for grantConsent without sending the request
     */
    async grantConsentRequestOpts(requestParameters: GrantConsentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['consentType'] == null) {
            throw new runtime.RequiredError(
                'consentType',
                'Required parameter "consentType" was null or undefined when calling grantConsent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/consumer/consents/{consentType}`;
        urlPath = urlPath.replace(`{${"consentType"}}`, encodeURIComponent(String(requestParameters['consentType'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Grant consent of the specified type for the latest version of the document
     */
    async grantConsentRaw(requestParameters: GrantConsentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Diagnostics>> {
        const requestOptions = await this.grantConsentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DiagnosticsFromJSON(jsonValue));
    }

    /**
     * Grant consent of the specified type for the latest version of the document
     */
    async grantConsent(requestParameters: GrantConsentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Diagnostics> {
        const response = await this.grantConsentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for linkDevice without sending the request
     */
    async linkDeviceRequestOpts(requestParameters: LinkDeviceOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['device'] == null) {
            throw new runtime.RequiredError(
                'device',
                'Required parameter "device" was null or undefined when calling linkDevice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/consumer/devices/link`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LinkDeviceRequestToJSON(requestParameters['device']),
        };
    }

    /**
     * A device should be linked before any of the device related endpoints are used
     * This endpoint is used to link a device to the account
     */
    async linkDeviceRaw(requestParameters: LinkDeviceOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LinkDevice200Response>> {
        const requestOptions = await this.linkDeviceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LinkDevice200ResponseFromJSON(jsonValue));
    }

    /**
     * A device should be linked before any of the device related endpoints are used
     * This endpoint is used to link a device to the account
     */
    async linkDevice(requestParameters: LinkDeviceOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LinkDevice200Response> {
        const response = await this.linkDeviceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for revokeConsent without sending the request
     */
    async revokeConsentRequestOpts(requestParameters: RevokeConsentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['consentType'] == null) {
            throw new runtime.RequiredError(
                'consentType',
                'Required parameter "consentType" was null or undefined when calling revokeConsent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/consumer/consents/{consentType}`;
        urlPath = urlPath.replace(`{${"consentType"}}`, encodeURIComponent(String(requestParameters['consentType'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * All consent types are revoked if consent is revoked for type \"service\"
     * Revokes consent for all versions of the specified type of the consent document
     */
    async revokeConsentRaw(requestParameters: RevokeConsentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Diagnostics>> {
        const requestOptions = await this.revokeConsentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DiagnosticsFromJSON(jsonValue));
    }

    /**
     * All consent types are revoked if consent is revoked for type \"service\"
     * Revokes consent for all versions of the specified type of the consent document
     */
    async revokeConsent(requestParameters: RevokeConsentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Diagnostics> {
        const response = await this.revokeConsentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for setConfig without sending the request
     */
    async setConfigRequestOpts(requestParameters: SetConfigRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deviceId'] == null) {
            throw new runtime.RequiredError(
                'deviceId',
                'Required parameter "deviceId" was null or undefined when calling setConfig().'
            );
        }

        if (requestParameters['config'] == null) {
            throw new runtime.RequiredError(
                'config',
                'Required parameter "config" was null or undefined when calling setConfig().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/consumer/devices/{deviceId}/config`;
        urlPath = urlPath.replace(`{${"deviceId"}}`, encodeURIComponent(String(requestParameters['deviceId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ConfigToJSON(requestParameters['config']),
        };
    }

    /**
     * Set specified fields of a device\'s configuration
     */
    async setConfigRaw(requestParameters: SetConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Diagnostics>> {
        const requestOptions = await this.setConfigRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DiagnosticsFromJSON(jsonValue));
    }

    /**
     * Set specified fields of a device\'s configuration
     */
    async setConfig(requestParameters: SetConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Diagnostics> {
        const response = await this.setConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for unlinkDevice without sending the request
     */
    async unlinkDeviceRequestOpts(requestParameters: UnlinkDeviceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deviceId'] == null) {
            throw new runtime.RequiredError(
                'deviceId',
                'Required parameter "deviceId" was null or undefined when calling unlinkDevice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/consumer/devices/link/{deviceId}`;
        urlPath = urlPath.replace(`{${"deviceId"}}`, encodeURIComponent(String(requestParameters['deviceId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * After removing the link, no new data is received from the device. The historical data remains available. 
     * This endpoint is used to unlink a device from the account
     */
    async unlinkDeviceRaw(requestParameters: UnlinkDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Diagnostics>> {
        const requestOptions = await this.unlinkDeviceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DiagnosticsFromJSON(jsonValue));
    }

    /**
     * After removing the link, no new data is received from the device. The historical data remains available. 
     * This endpoint is used to unlink a device from the account
     */
    async unlinkDevice(requestParameters: UnlinkDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Diagnostics> {
        const response = await this.unlinkDeviceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateAccount without sending the request
     */
    async updateAccountRequestOpts(requestParameters: UpdateAccountOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling updateAccount().'
            );
        }

        if (requestParameters['updateData'] == null) {
            throw new runtime.RequiredError(
                'updateData',
                'Required parameter "updateData" was null or undefined when calling updateAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/consumer/account/{accountId}`;
        urlPath = urlPath.replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters['accountId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateAccountRequestToJSON(requestParameters['updateData']),
        };
    }

    /**
     * Update the properties of a specific account.
     */
    async updateAccountRaw(requestParameters: UpdateAccountOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.updateAccountRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update the properties of a specific account.
     */
    async updateAccount(requestParameters: UpdateAccountOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateAccountRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for updateUser without sending the request
     */
    async updateUserRequestOpts(requestParameters: UpdateUserOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling updateUser().'
            );
        }

        if (requestParameters['updateData'] == null) {
            throw new runtime.RequiredError(
                'updateData',
                'Required parameter "updateData" was null or undefined when calling updateUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/consumer/users/{userId}`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateUserRequestToJSON(requestParameters['updateData']),
        };
    }

    /**
     * Update the properties of a specific user.
     */
    async updateUserRaw(requestParameters: UpdateUserOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Diagnostics>> {
        const requestOptions = await this.updateUserRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DiagnosticsFromJSON(jsonValue));
    }

    /**
     * Update the properties of a specific user.
     */
    async updateUser(requestParameters: UpdateUserOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Diagnostics> {
        const response = await this.updateUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateUserRoleByEmail without sending the request
     */
    async updateUserRoleByEmailRequestOpts(requestParameters: UpdateUserRoleByEmailOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['updateData'] == null) {
            throw new runtime.RequiredError(
                'updateData',
                'Required parameter "updateData" was null or undefined when calling updateUserRoleByEmail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/consumer/users/role`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateUserRoleByEmailRequestToJSON(requestParameters['updateData']),
        };
    }

    /**
     * Update a user\'s role by email.
     */
    async updateUserRoleByEmailRaw(requestParameters: UpdateUserRoleByEmailOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Diagnostics>> {
        const requestOptions = await this.updateUserRoleByEmailRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DiagnosticsFromJSON(jsonValue));
    }

    /**
     * Update a user\'s role by email.
     */
    async updateUserRoleByEmail(requestParameters: UpdateUserRoleByEmailOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Diagnostics> {
        const response = await this.updateUserRoleByEmailRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetConsentConsentTypeEnum = {
    Service: 'service',
    Privacy: 'privacy'
} as const;
export type GetConsentConsentTypeEnum = typeof GetConsentConsentTypeEnum[keyof typeof GetConsentConsentTypeEnum];
/**
 * @export
 */
export const GetHistoryRangeResolutionEnum = {
    Original: 'original',
    Second: 'second',
    Minute: 'minute',
    Hour: 'hour',
    Day: 'day',
    Week: 'week',
    Month: 'month',
    Year: 'year'
} as const;
export type GetHistoryRangeResolutionEnum = typeof GetHistoryRangeResolutionEnum[keyof typeof GetHistoryRangeResolutionEnum];
/**
 * @export
 */
export const GetHistoryRangeSystemResolutionEnum = {
    Original: 'original',
    Second: 'second',
    Minute: 'minute',
    Hour: 'hour',
    Day: 'day',
    Week: 'week',
    Month: 'month',
    Year: 'year'
} as const;
export type GetHistoryRangeSystemResolutionEnum = typeof GetHistoryRangeSystemResolutionEnum[keyof typeof GetHistoryRangeSystemResolutionEnum];
/**
 * @export
 */
export const GrantConsentConsentTypeEnum = {
    Service: 'service',
    Privacy: 'privacy'
} as const;
export type GrantConsentConsentTypeEnum = typeof GrantConsentConsentTypeEnum[keyof typeof GrantConsentConsentTypeEnum];
/**
 * @export
 */
export const RevokeConsentConsentTypeEnum = {
    Service: 'service',
    Privacy: 'privacy'
} as const;
export type RevokeConsentConsentTypeEnum = typeof RevokeConsentConsentTypeEnum[keyof typeof RevokeConsentConsentTypeEnum];
